import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'subStringPipe'
})
export class SubStringPipe implements PipeTransform {

  transform(value: any): any {
    let output = "";
    if (value.lastName != null) {
      output = value.firstName + " " + value.lastName;
    } else {
      output = value.firstName;
    }
    if (output.length > 57) {
      return output.substring(0, 57) + "...";
    } else {
      return output;
    }
  }

}
